import { BrowserCacheLocation, Configuration, LogLevel } from '@azure/msal-browser';

const MITEK_LICENSE_KEY = 'eyJzaWduYXR1cmUiOiJqN1VEZVBFTEZ4LzJxeVh3aUdoaVd1UmhPdE5BSGdaUkRabnNlM0FKdnVaSDIva01sNzAraDg2Q0ZiaXhyQ20xVnNRWFl2MEtPbWFFeWt2eTNURzVRM0g4RUdsamdvdUluSERwRmtWdGRrR090OWplaFhWbHhTU3ZKcnRHTFBPTHJIR0lnWlZlV0xJUGRaVklVQ0RHdGRKQnZKRGorOE1VUmNneEdBekw1UENZRkRnWjNVSlRJd1RVTDRCZUpHczRDMWcyTlB0ZlNmUTJhYmt5ZGxMWS9mMGdjNkkxVkxTWnNvMEtQVWIzaW16eXN2M3VQRFlQNTN5c1ltdTl0bitGMzZyU2ErQlZUWlE5VktUVFZDWGxoaGRNQURLU0dCN0R4TW94dWs4NG8rUVE4eU5URjB0UFR4T0swNjg4bm41UmV2QXdrWlNpY2d2QkJTbm9ESXhudGc9PSIsInNpZ25lZCI6eyJleHBpcnkiOiIyMDI2LTEyLTMwIiwiZmVhdHVyZXMiOlsiYmFyY29kZSIsImZhY2UiLCJnZW5lcmljIiwiaWQiXSwiYXBwbGljYXRpb25JZGVudGlmaWVyIjp7IndlYiI6WyIqLmZhZHYubmV0IiwiKi5mYWR2LmNvbSJdfSwiZ3BvIjoiMTZkIiwib3JnYW5pemF0aW9uIjoiTWl0ZWsgU3lzdGVtcyBJbmMuIiwidmVyc2lvbiI6IjEuMCJ9LCJiYXJjb2RlV2ViTGljZW5zZSI6IjJXbGZFNHVEVE1tYnRqeU5EbCtQRE9NL2ViTDhoQXFQMm8wVHR5RHhua3Q3VkNuZjlDazhKN2lZU28zb2U1bHY0L21TTHhjMjlXbW8zNkF1dC9OYy9pWUJSbUY4RmxDMGw2ZmZVeFZBaWIxWHhjcHQvaDMrOG82cnBsYldCa0h6SkVMTzNzUVNVODNzZ2lrWmVvVkZFOHY5WDNPUC9oSmh5VlloZVRoQ0VHUlVjeWxTWTVZQzhjMVRNMHR5alYwdkYxVTZXVCtwcVFQZTM5OTJIeER1SXVjWGFGdXFPbGNPd3ZrWnVRalpLaXU5TEtUcUZJQVBMQk51V3puWGc2ZWhFbk9kMklkc2xEVWNKak9venViV2ZMS3k2VEpWQjlwbDJkdEErNUQ0b3VLWVFYUE45QStEblVwODNaSE8wOWUzb2JBNTFhcWY2NDNSNGlmb0NTWnBZTGtrL3RKRnE0UGdveE1UUXd6VkNLMkVDUnhKM2FKNzNkQnVHTVBrZFYzaDNUYzBJZ1dSc3p5cEhxWm84SVUyempnYnNGdFZ4emtMNEJWRnJmL3hDNkg3RGtCREU0aGJEV2pZNkN5VUtuMGljcVZ5ZU1TaXY3azZib0ZpNll6dGlNRkwwd1MvV1BIMWZ2MlFkNmpkSWk5RGROeHdEbVpyaVNoNlQ3UitNVGZWIn0=';

//Authy begin
export type MfaType = 'magiclink' | 'sms' | 'magiclink+sms' |'test';
const clientId = 'ded132e7-e021-4b2a-8e89-b90aaed28169';
const tenant = 'authyfaexternaluat.onmicrosoft.com';
const authority = 'https://authy.uat.switch.fadv.com';
const policyNames = {
  // sign up policy when only magic link is required
  signinMagicLink: 'B2C_1A_V2_SIGNIN_WITH_MAGICLINK',
  // invite policy when only magic link is required
  inviteMagicLink: 'B2C_1A_V2_SIGNUP_BY_INVITE_MAGICLINK',
  // sign up policy when only sms is required
  signinSms: 'B2C_1A_V2_SIGNIN_WITH_SMS',
  // sign in policy for tests only
  signIn: 'B2C_1A_V2_SIGNIN',
  // sign up policy for tests only
  signUp: 'B2C_1A_V2_SIGNUP',
  // invite policy when only sms is required
  inviteSms: 'B2C_1A_V2_SIGNUP_BY_INVITE_SMS',
  // sign in policy when user can select MFA type when magic link and sms is an option
  signinSelectMFA: 'B2C_1A_V2_SIGNIN_SELECT_MFA',
  // sign up policy where user verified email with magic link and setups MFA with sms
  inviteMagicLinkSms: 'B2C_1A_V2_SIGNUP_INVITE_WITH_MAGICLINK_SMS',
  // password reset
  passwordReset: 'B2C_1A_V2_PASSWORDRESET',
    // password reset Sms
  passwordResetSms: 'B2C_1A_V2_PASSWORDRESET_SMS',
  // continues auth after magic link
  signInByToken: 'B2C_1A_V2_SIGNIN_WITH_LINK_TOKEN',
  // update phone number
  changePhoneNumber: 'B2C_1A_V2_UPDATE_PHONE_NUMBER'
};
type PolicyKey = keyof typeof policyNames;
type Policies = Record<PolicyKey, { name: string; authority: string; }>;
const policies = Object.keys(policyNames).reduce((acc, key) => {
  const name = policyNames[key as PolicyKey];
  return { ...acc, [key]: { name, authority: `${authority}/${tenant}/${name}` } };
}, {}) as Policies;

const invitePolicies: Record<'signin' | 'signup', Record<MfaType, string>> = {
  signin: {
    magiclink: policies.signinMagicLink.authority,
    sms: policies.signinSms.authority,
    'magiclink+sms': policies.signinSelectMFA.authority,
    test: policies.signIn.authority
  },
  signup: {
    magiclink: policies.inviteMagicLink.authority,
    sms: policies.inviteSms.authority,
    'magiclink+sms': policies.inviteMagicLinkSms.authority,
    test: policies.signUp.authority
  },
};
const restartSigninPolicies: Record<Exclude<MfaType, 'test'>, string> = {
  magiclink: policies.signinMagicLink.authority,
  sms: policies.signinSms.authority,
  'magiclink+sms': policies.signinSelectMFA.authority,
};

const msalConfig: Configuration = {
  auth: {
    clientId: clientId,
    authority: policies.signinMagicLink.authority,
    knownAuthorities: [authority],
    redirectUri: '/',
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
  system: {
    loggerOptions: {
      loggerCallback: (_logLevel, message, containsPii) => {
        if (containsPii) {
          return;
        }

        console.log(message);
      },
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false,
    },
  },
};
//Authy end

export const environment = {
    production: true,
    name: 'uat',
    apiUrl: 'https://pa-ua.fadv.com',
    global_error_show: false,
    apm_environment: 'uat',
    minAndroidVersion: 9,
    enableConsoleDebugging: false,
    minIosVersion: 12,
    minChromeVersion: 64,
    minFirefoxVersion: 55,
    minIExplorerVersion: 11,
    minSafariVersion: 9,
    camerasettings: {
      captureMode : 'Auto'
    },
    websdk_vendor: 'MITEK',
    verification_api_vendor: 'MITEK',
    languageEditEnabled: false,
    crowdin_hashCode: 'euw1-168f87ed23c4951b53b3lry',
    default_language: 'en',
    google_api_key: 'AIzaSyAU88N0EBLhmlwTB1N7NcT1lmqkKEt9xpI',
    rumId: 'AD-AAB-ABF-YDH',
    yoti_client_sdk_id: 'e72baa96-8df9-4164-ad76-569b06413370',
    default_chat_exp : 'AI',
    chatbotContactType: 'Candidate',
    chatbotApiKey: 'bhnxtkkesxfpu87gv59wlvt779dvxmsl',
    chatbotApiUrl: 'https://uat01-ax.na.sc.fadv.com/api/v1/sc-chatbot-api-v1',
    stripe_pk: "pk_test_51NfjJ1A0emjIZImakLQOXaMVRxb1KziwqFjPXhTafFKNWGt75qF3mgIUVAqTAr7DJB9witVwJ26VYGM4gY9BB6j000GMoLfERB",
    payli_us_pk: "pk_test_51Rarc42SNPOJ72uAFOPEEx0NVsg2oYtKHcrYp2z9S4DAKqYSZGB3Qh4BZy2xzS9nWf7RoM3oG5ptPyMF1ypKicnK00o3zJc8jW",
    payli_cad_pk: "pk_test_51RarPQDEljr1PWpBwpiWsZbFY3uNctvV0jGRcWndSyyIxf9KyjEwq3Gxnyg01crvd45qvwSfXqBd9E12faY4Wwpl00WPla7kxV",
    cognitive_search_key: 'oKgbkv15ibxluqfXIswnL2XcesGqNhnw0CsGlJI76QAzSeAZ7ycy',
    clarity_id: "qm2u0tl0a6",
    hotjar_id: 3779754,
    app_insights_connection_string: "",
    //Authy begin
    clientId,
    authority,
    authorityUrl: `${authority}/${tenant}`,
    policies,
    invitePolicies,
    restartSigninPolicies,
    msalConfig,
    magicLinkPolicies: {
      'password-reset': policies.passwordReset.authority,
      'restart-password-reset': policies.passwordReset.authority,
      'password-reset-sms': policies.passwordResetSms.authority,
      'restart-password-reset-sms': policies.passwordResetSms.authority,
      'signin': policies.signInByToken.authority,
      // this will be the default, it may depend on what policy was initially used
      'restart-signin': policies.signinMagicLink.authority,
      'update-phonenumber': policies.changePhoneNumber.authority,
      'restart-update-phonenumber': policies.changePhoneNumber.authority
    },
    // default is the name of the scope that was registered with the application, an application can have multiple scopes
    scopes: [`https://${tenant}/${clientId}/default`],
    endpoints: {
      invite: 'http://localhost:3000/api/invite',
    },
    //Authy end
    mitekLicenseKey: MITEK_LICENSE_KEY,
    miawChatEmbeddedServiceMinJS: 'https://firstadvantage--fulltest.sandbox.my.site.com/ESWDee1751308029715/assets/js/bootstrap.min.js',
    miawOrgId: '00DWL000002fiFF',
    miawEswConfigDevName: 'Dee',
    miawCommunityEndpointURL: 'https://firstadvantage--fulltest.sandbox.my.site.com/ESWDee1751308029715',
    miawScrt2URL: 'https://firstadvantage--fulltest.sandbox.my.salesforce-scrt.com',
    // Osano Consent Management Platform Configuration
    osano_customer_id: "AzZdIASnpdcMc54D5",
    osano_config_id: "6ad0279e-cbe7-4020-b421-c493aa710a36",  // Authy UAT + NGPA
  };